'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reduxForm = require('redux-form');

var _reactBootstrap = require('react-bootstrap');

var _reactSignatureCanvas = require('react-signature-canvas');

var _reactSignatureCanvas2 = _interopRequireDefault(_reactSignatureCanvas);

var _LabelledInputComponent = require('../../../components/input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _StaticComponent = require('../../../components/common/StaticComponent');

var _StaticComponent2 = _interopRequireDefault(_StaticComponent);

var _SelectComponent = require('../../../components/input/SelectComponent');

var _SelectComponent2 = _interopRequireDefault(_SelectComponent);

var _InputComponent = require('../../../components/input/InputComponent');

var _InputComponent2 = _interopRequireDefault(_InputComponent);

var _TextInputComponent = require('../../../components/input/TextInputComponent');

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _CheckboxComponent = require('../../../components/input/CheckboxComponent');

var _CheckboxComponent2 = _interopRequireDefault(_CheckboxComponent);

var _SectionHeaderComponent = require('../../../components/common/SectionHeaderComponent');

var _SectionHeaderComponent2 = _interopRequireDefault(_SectionHeaderComponent);

var _ButtonControllerComponent = require('../../../components/common/dynamic/ButtonControllerComponent');

var _ButtonControllerComponent2 = _interopRequireDefault(_ButtonControllerComponent);

var _MshApplicantComponent = require('../../../components/common/MshApplicantComponent');

var _MshApplicantComponent2 = _interopRequireDefault(_MshApplicantComponent);

var _ExpatQuoteComponent = require('../../../components/common/ExpatQuoteComponent');

var _ExpatQuoteComponent2 = _interopRequireDefault(_ExpatQuoteComponent);

var _SubmitButtonComponent = require('../../../components/input/SubmitButtonComponent');

var _SubmitButtonComponent2 = _interopRequireDefault(_SubmitButtonComponent);

var _EmailQuoteButtonComponent = require('../../../components/input/EmailQuoteButtonComponent');

var _EmailQuoteButtonComponent2 = _interopRequireDefault(_EmailQuoteButtonComponent);

var _DatePickerComponent = require('../../../components/input/DatePickerComponent');

var _DatePickerComponent2 = _interopRequireDefault(_DatePickerComponent);

var _CurrencyInputComponent = require('../../../components/input/CurrencyInputComponent');

var _CurrencyInputComponent2 = _interopRequireDefault(_CurrencyInputComponent);

var _formConfiguration = require('../../../transformers/common/formConfiguration');

var _formConfiguration2 = _interopRequireDefault(_formConfiguration);

var _questionnaire = require('../../../transformers/msh/global2go/questionnaire');

var _questionnaire2 = _interopRequireDefault(_questionnaire);

var _MshActionCreators = require('../../../actions/MshActionCreators');

var _Quote = require('../../../validators/msh/Quote');

var _Quote2 = _interopRequireDefault(_Quote);

var _translate = require('../../../language/translate');

var _MshErrorDivComponent = require('../../../components/common/MshErrorDivComponent');

var _MshErrorDivComponent2 = _interopRequireDefault(_MshErrorDivComponent);

var _InitialValues = require('../../common/InitialValues');

var _InitialValues2 = _interopRequireDefault(_InitialValues);

var _RadioGroupComponent = require('../../../components/input/RadioGroupComponent');

var _RadioGroupComponent2 = _interopRequireDefault(_RadioGroupComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */

var fields = ['applicant.dob', 'application.email', 'applicants[]', 'application.additional_data.applicant_type', 'application.additional_data.applicant_firstname', 'application.additional_data.applicant_lastname', 'application.additional_data.applicant_dob', 'application.additional_data.applicant_gender', 'application.additional_data.applicant_clientname', 'application.additional_data.applicant_relationshiptoprimary', 'application.additional_data.applicant_policy', 'application.additional_data.1a', 'application.additional_data.1b', 'application.additional_data.2base', 'application.additional_data.2a', 'application.additional_data.2a_date', 'application.additional_data.2a_address', 'application.additional_data.2a_details', 'application.additional_data.2b_date', 'application.additional_data.2b_address', 'application.additional_data.2b_details', 'application.additional_data.2c_date', 'application.additional_data.2c_address', 'application.additional_data.2c_details', 'application.additional_data.2d_date', 'application.additional_data.2d_address', 'application.additional_data.2d_details', 'application.additional_data.2e_date', 'application.additional_data.2e_address', 'application.additional_data.2e_details', 'application.additional_data.2f_date', 'application.additional_data.2f_address', 'application.additional_data.2f_details', 'application.additional_data.2g_date', 'application.additional_data.2g_address', 'application.additional_data.2g_details', 'application.additional_data.2h_date', 'application.additional_data.2h_address', 'application.additional_data.2h_details', 'application.additional_data.2i_date', 'application.additional_data.2i_address', 'application.additional_data.2i_details', 'application.additional_data.2j_date', 'application.additional_data.2j_address', 'application.additional_data.2j_details', 'application.additional_data.2k_date', 'application.additional_data.2k_address', 'application.additional_data.2k_details', 'application.additional_data.2l_date', 'application.additional_data.2l_address', 'application.additional_data.2l_details', 'application.additional_data.2m_date', 'application.additional_data.2m_address', 'application.additional_data.2m_details', 'application.additional_data.2b', 'application.additional_data.2c', 'application.additional_data.2d', 'application.additional_data.2e', 'application.additional_data.2f', 'application.additional_data.2g', 'application.additional_data.2h', 'application.additional_data.2i', 'application.additional_data.2j', 'application.additional_data.2k', 'application.additional_data.2l', 'application.additional_data.2m', 'application.additional_data.3base', 'application.additional_data.3a', 'application.additional_data.3b', 'application.additional_data.3c', 'application.additional_data.3d', 'application.additional_data.3d_date', 'application.additional_data.3d_address', 'application.additional_data.3d_details', 'application.additional_data.4a', 'application.additional_data.4a_date', 'application.additional_data.4a_address', 'application.additional_data.4a_details', 'application.additional_data.4b', 'application.additional_data.4c', 'application.additional_data.4d', 'application.additional_data.4e', 'application.additional_data.5a', 'application.additional_data.5b', 'application.additional_data.5c', 'application.additional_data.5d', 'application.additional_data.6base', 'application.additional_data.6a', 'application.additional_data.6a_date', 'application.additional_data.6a_address', 'application.additional_data.6a_details', 'application.additional_data.6b', 'application.additional_data.6b_date', 'application.additional_data.6b_address', 'application.additional_data.6b_details', 'application.additional_data.6c', 'application.additional_data.6c_date', 'application.additional_data.6c_address', 'application.additional_data.6c_details', 'application.additional_data.7base', 'application.additional_data.7a', 'application.additional_data.7a_date', 'application.additional_data.7a_address', 'application.additional_data.7a_details', 'application.additional_data.7b', 'application.additional_data.7b_date', 'application.additional_data.7b_address', 'application.additional_data.7b_details', 'application.additional_data.7c', 'application.additional_data.7d', 'application.additional_data.8a', 'application.additional_data.8a_date', 'application.additional_data.8a_address', 'application.additional_data.8a_details', 'application.additional_data.9a', 'application.additional_data.9a_date', 'application.additional_data.9a_address', 'application.additional_data.9a_details', 'application.additional_data.9b', 'application.additional_data.9b_date', 'application.additional_data.9b_address', 'application.additional_data.9b_details', 'application.additional_data.10a', 'application.additional_data.10a_date', 'application.additional_data.10a_address', 'application.additional_data.10a_details', 'application.additional_data.10b', 'application.additional_data.10b_date', 'application.additional_data.10b_address', 'application.additional_data.10b_details', 'application.additional_data.11a', 'application.additional_data.11a_date', 'application.additional_data.11a_address', 'application.additional_data.11a_details', 'application.additional_data.auth1', 'application.additional_data.auth2', 'application.additional_data.auth3', 'application.additional_data.auth4', 'application.additional_data.auth5', 'application.additional_data.privacy1', 'application.additional_data.privacy2', 'application.additional_data.signature', 'application.additional_data.signature_date'];

/**
 * Renders the part of the form which generates a live quote.
 * @extends {Component}
 */

var QuestionnaireComponent = function (_React$Component) {
  _inherits(QuestionnaireComponent, _React$Component);

  function QuestionnaireComponent(props) {
    _classCallCheck(this, QuestionnaireComponent);

    var _this = _possibleConstructorReturn(this, (QuestionnaireComponent.__proto__ || Object.getPrototypeOf(QuestionnaireComponent)).call(this, props));

    _this.getSignature = function () {
      return !_this.sigCanvas.isEmpty() ? _this.sigCanvas.toDataURL('image/png') : null;
    };

    _this.clearSign = function () {
      _this.sigCanvas.clear();
    };

    _this.onChangeHook = _this.onChangeHook.bind(_this);
    _this.submitQuestionnaire = _this.submitQuestionnaire.bind(_this);
    _this.getSignature = _this.getSignature.bind(_this);
    _this.checkError = _this.checkError.bind(_this);
    _this.hideModal = _this.hideModal.bind(_this);
    _this.getApplicantInfo = _this.getApplicantInfo.bind(_this);
    _this.setApplicantInfo = _this.setApplicantInfo.bind(_this);
    _this.clearSign = _this.clearSign.bind(_this);
    _this.applicantInfo = [];

    _this.state = {
      showModal: true
    };

    _this.fieldTypes = {
      StaticComponent: _StaticComponent2.default,
      SelectComponent: _SelectComponent2.default,
      InputComponent: _InputComponent2.default,
      TextInputComponent: _TextInputComponent2.default,
      CurrencyInputComponent: _CurrencyInputComponent2.default,
      DatePickerComponent: _DatePickerComponent2.default,
      RadioGroupComponent: _RadioGroupComponent2.default,
      CheckboxComponent: _CheckboxComponent2.default,
      get: function get(name) {
        return Object.prototype.hasOwnProperty.call(this, name) ? this[name] : _TextInputComponent2.default;
      }
    };
    return _this;
  }

  _createClass(QuestionnaireComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.formConfig = (0, _formConfiguration2.default)(this.props.formConfig)[0].fields;
      this.questionnaire = this.props.msh.questionnaire;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.scrollToTop && this.props.msh.questionnaire.information != null) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.state.scrollToTop = false;
      }
    }
  }, {
    key: 'onChangeHook',
    value: function onChangeHook() {}
  }, {
    key: 'getApplicantInfo',
    value: function getApplicantInfo() {
      if (this.props.msh.questionnaire.applicantInfo !== undefined && this.props.msh.questionnaire.result) {
        this.applicantInfo.first_name = this.props.msh.questionnaire.result.first_name;
        this.applicantInfo.last_name = this.props.msh.questionnaire.result.last_name;
        this.applicantInfo.dob = this.props.msh.questionnaire.result.dob;
        this.applicantInfo.gender = this.props.msh.questionnaire.result.gender;
        this.applicantInfo.client_name = this.props.msh.questionnaire.result.client_name;
        this.applicantInfo.relationship_to_primary = this.props.msh.questionnaire.result.relationship_to_primary;
        this.applicantInfo.reference_id = this.props.msh.questionnaire.result.reference_id;
        this.applicantInfo.applicant_type = this.props.msh.questionnaire.result.applicant_type;
      }
    }
  }, {
    key: 'setApplicantInfo',
    value: function setApplicantInfo() {
      if (Object.keys(this.applicantInfo).length > 0 && this.props.fields.application.additional_data.applicant_type.value === '') {
        this.props.fields.application.additional_data.applicant_clientname.value = this.applicantInfo.client_name;
        this.props.fields.application.additional_data.applicant_policy.value = this.applicantInfo.reference_id;
        this.props.fields.application.additional_data.applicant_type.value = this.applicantInfo.applicant_type;

        if (this.applicantInfo.first_name) {
          this.props.fields.application.additional_data.applicant_firstname.value = this.applicantInfo.first_name;
        }

        if (this.applicantInfo.last_name) {
          this.props.fields.application.additional_data.applicant_lastname.value = this.applicantInfo.last_name;
        }

        if (this.applicantInfo.dob) {
          this.props.fields.application.additional_data.applicant_dob.value = this.applicantInfo.dob;
        }

        if (this.applicantInfo.gender) {
          this.props.fields.application.additional_data.applicant_gender.value = this.applicantInfo.gender;
        }

        if (this.applicantInfo.relationship_to_primary) {
          this.props.fields.application.additional_data.applicant_relationshiptoprimary.value = this.applicantInfo.relationship_to_primary;
        }
      }
    }
  }, {
    key: 'checkError',
    value: function checkError(fieldPath) {
      if (this.props.msh.questionnaire.information) {
        var fieldErrors = this.props.msh.questionnaire.information.filter(function (el) {
          return el.key === fieldPath;
        });
        return fieldErrors.length !== 0;
      }
      return false;
    }
  }, {
    key: 'hideModal',
    value: function hideModal() {
      this.setState({ showModal: false });
    }
  }, {
    key: 'submitQuestionnaire',
    value: function submitQuestionnaire() {
      this.state.showModal = true;
      this.props.dispatch((0, _MshActionCreators.submitQuestionnaire)(this.props, this.getSignature()));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      this.getApplicantInfo();
      this.setApplicantInfo();

      return _react2.default.createElement(
        'div',
        { className: 'form-horizontal' },
        this.props.msh.questionnaire.result ? this.props.msh.questionnaire.result.complete ? null : _react2.default.createElement(
          'div',
          null,
          _config2.default.clients.msh[this.props.formName].questionnaire.form_config.map(function (section, sectionIndex) {
            return _react2.default.createElement(
              'div',
              { className: 'form-section' },
              _react2.default.createElement(
                _SectionHeaderComponent2.default,
                null,
                (0, _translate.t)(section.header)
              ),
              section.fields.map(function (field, index) {
                var _this2 = this;

                var showFlag = true;
                field.component_props.onChangeHook = field.component_props.onChange ? function () {
                  return _this2[field.component_props.onChange]();
                } : null;

                if (field.show_if !== undefined) {
                  field.show_if.map(function (show_if_field, fieldIndex) {
                    if (show_if_field.value.indexOf(this.props.fields.application.additional_data[show_if_field.key_path].value) === -1) {
                      showFlag = false;
                      return null;
                    }
                    return null;
                  }, this);
                }

                var fieldTitle = this.formConfig[field.config_path].key ? this.formConfig[field.config_path].key + '. ' + this.formConfig[field.config_path].title : this.formConfig[field.config_path].title;

                return showFlag ? _react2.default.createElement(_LabelledInputComponent2.default, {
                  key: index,
                  isStatic: field.isStatic,
                  inputId: field.id,
                  inputLabel: fieldTitle,
                  inputComponent: this.fieldTypes.get(field.component_type),
                  inputComponentField: this.props.fields.application.additional_data[field.field_key],
                  inputComponentProps: field.component_props,
                  leftIndent: field.show_if,
                  hasExpandableHint: field.hasExpandableHint,
                  expandableHintId: field.expandableHintId,
                  expandableHintTitle: field.hasExpandableHint ? this.formConfig[field.expandableHintPath].title : null,
                  expandableHintContent: field.hasExpandableHint ? this.formConfig[field.expandableHintPath].hint : null,
                  expandableHintIsRawHtml: field.expandableHintIsRawHtml,
                  hasError: this.checkError('questionnaire.additional_data.' + field.field_key),
                  size: field.size ? field.size : 6
                }) : null;
              }, this)
            );
          }, this),
          _react2.default.createElement(
            'div',
            { className: 'SignatureContainer' },
            _react2.default.createElement(
              'div',
              null,
              'Please sign in the box below'
            ),
            _react2.default.createElement(
              'div',
              { className: 'sigcont' },
              _react2.default.createElement(_reactSignatureCanvas2.default, {
                penColor: 'green',
                canvasProps: { width: 500, height: 200, className: 'sigCanvas' },
                ref: function ref(_ref) {
                  _this3.sigCanvas = _ref;
                }
              })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                { onClick: this.clearSign },
                'Clear Signature'
              )
            )
          )
        ) : _react2.default.createElement(
          'div',
          null,
          'The questionnaire link is invalid'
        ),
        _react2.default.createElement(_MshErrorDivComponent2.default, {
          errors: this.props.msh.questionnaire.information
        }),
        this.props.msh.questionnaire.result && !this.props.msh.questionnaire.result.complete ? _react2.default.createElement(
          'div',
          { className: 'div-center padding-topbottom-20' },
          _react2.default.createElement(
            _EmailQuoteButtonComponent2.default,
            {
              isFormSubmitting: this.props.submitting,
              isFormInvalid: false,
              onClickAction: this.submitQuestionnaire,
              disabled: false
            },
            (0, _translate.t)(_config2.default.messages.submit_questionnaire)
          )
        ) : null,
        _react2.default.createElement(
          _reactBootstrap.Modal,
          { show: this.state.showModal && this.props.msh.questionnaire.result && this.props.msh.questionnaire.result.complete },
          _react2.default.createElement(
            'div',
            { className: 'modal-button' },
            _react2.default.createElement(
              'h2',
              { className: 'padding-left quote-price-display' },
              (0, _translate.t)(_config2.default.messages.questionnaire_success)
            ),
            _react2.default.createElement(
              'div',
              { className: '' },
              _react2.default.createElement(
                'button',
                { className: 'btn btn-primary button margin-left', onClick: this.hideModal },
                (0, _translate.t)(_config2.default.messages.close)
              )
            )
          )
        )
      );
    }
  }]);

  return QuestionnaireComponent;
}(_react2.default.Component);

QuestionnaireComponent.propTypes = _extends({}, _reduxForm.propTypes, {
  params: _react2.default.PropTypes.object,
  auth: _react2.default.PropTypes.object,
  application: _react2.default.PropTypes.object,
  formConfig: _react2.default.PropTypes.object,
  trackingCode: _react2.default.PropTypes.string
});


var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.api.authorization,
    msh: state.msh,
    formConfig: state.formConfig.config
  };
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'genericis',
  fields: fields,
  destroyOnUnmount: false,
  touchOnBlur: false,
  validate: _Quote2.default
}, mapStateToProps)(QuestionnaireComponent);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/msh/questionnaire/QuestionnaireContainer.jsx
// module id = 1684
// module chunks = 0